import {Modal, Form, Button, Alert} from 'react-bootstrap';
import {useState, useMemo} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import API from '../helpers/api';

export default function ChangeAgentPasswordModal({show, close, agent}) {
    const dispatch = useDispatch();
    const api = useMemo(() => new API({dispatch}), [dispatch]);
    const [formData, setFormData] = useState({
        user_password: '',
        confirm_password: ''
    });
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [error, setError] = useState(null);
    const [success, setSuccess] = useState(null);

    const handleChange = (e) => {
        const {name, value} = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: value
        }));
    }
    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsSubmitting(true);
        setError(null);
        setSuccess(null);
        if (formData.user_password !== formData.confirm_password) {
            setError("Passwords do not match");
            setIsSubmitting(false);
            return;
        }
        try {
            await api.updateAgentPassword(agent.id, formData.user_password);
            setSuccess("Password changed successfully");
            setFormData({ user_password: '', confirm_password: '' });
        } catch (error) {
            setError("Error changing password");
            console.error('Error changing password:', error);
        } finally {
            setIsSubmitting(false);
        }
    }
    return (
        <Modal show={show} onHide={close}>
            <Modal.Header closeButton>
                <Modal.Title>Change Password for {agent.first_name} {agent.last_name}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {error && <Alert variant="danger">{error}</Alert>}
                {success && <Alert variant="success">{success}</Alert>}
                <Form onSubmit={handleSubmit}>
                    <Form.Group className="mb-3" controlId="user_password">
                        <Form.Label>New Password</Form.Label>
                        <Form.Control
                            type="password"
                            name="user_password"
                            value={formData.user_password}
                            onChange={handleChange}
                            required
                        /> 
                    </Form.Group>
                    <Form.Group className="mb-3" controlId="confirm_password">
                        <Form.Label>Confirm New Password</Form.Label>
                        <Form.Control
                            type="password"
                            name="confirm_password"
                            value={formData.confirm_password}
                            onChange={handleChange}
                            required
                        />
                    </Form.Group>
                    <Button variant="primary" type="submit" disabled={isSubmitting}>
                        {isSubmitting ? 'Changing...' : 'Change Password'}
                    </Button>
                </Form>
            </Modal.Body>
        </Modal>
    );
}